// Helper per la "Chiusura per ferie" degli artigiani.

export function toISODate(d) {
  if (!d) return null;
  const dt = new Date(d);
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, '0');
  const day = String(dt.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatDateIt(d) {
  if (!d) return '';
  const dt = typeof d === 'string' ? new Date(`${d}T00:00:00`) : new Date(d);
  return dt.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

// Ritorna lo stato ferie a partire da un profilo (con vacation_start/end/message).
export function vacationStatus(profile) {
  const vs = profile?.vacation_start;
  const ve = profile?.vacation_end;
  if (!vs || !ve) return { active: false, start: null, end: null, message: null };
  const today = toISODate(new Date());
  const active = vs <= today && today <= ve;
  return { active, start: vs, end: ve, message: profile?.vacation_message || null };
}
